import type {
  V1BatchGetAggregatesRequest,
  V1BatchGetAggregatesResponse,
  V1BatchUpdateAggregatesRequest,
  V1BatchUpdateAggregatesResponse,
  V1ResolveAggregateSensitiveDataRequest,
  V1ResolveAggregateSensitiveDataResponse,
  V1SendAggregateRequest,
  V1SendAggregateResponse,
} from '@blk/aladdin-graph-client-axios-internal/wealth/portfolio_management/portfolios/v1/aggregate_api';
import type { PortfolioManagementportfoliosv1Mandate } from '@blk/aladdin-graph-client-axios-internal/wealth/portfolio_management/portfolios/v1/mandate_api';
import { awPortfolioManagementApi } from './Base';
import {
  AgraphGetAggregatesRequestBody,
  AgraphGetAggregatesResponseBody,
  BatchDeleteAggregatesRequestBody,
} from './types';

const AGGREGATES_PATH = 'portfolios/v1/aggregates';

export function postSendAggregates(request: V1SendAggregateRequest) {
  const path = `${AGGREGATES_PATH}:send`;
  return awPortfolioManagementApi.post<V1SendAggregateResponse>(path, request);
}

export function postBatchGetAggregates(getAggregatesRequest: V1BatchGetAggregatesRequest) {
  const path = `${AGGREGATES_PATH}:batchGet`;
  return awPortfolioManagementApi.post<V1BatchGetAggregatesResponse>(path, getAggregatesRequest);
}

export function postGetAggregates(getAggregatesRequest: AgraphGetAggregatesRequestBody) {
  const path = `${AGGREGATES_PATH}:batchGet`;
  return awPortfolioManagementApi.post<AgraphGetAggregatesResponseBody>(path, getAggregatesRequest);
}

export function postBatchDeleteAggregates(batchDeleteAggregatesRequest: BatchDeleteAggregatesRequestBody) {
  const path = `${AGGREGATES_PATH}:batchDelete`;
  return awPortfolioManagementApi.post<void>(path, batchDeleteAggregatesRequest);
}

export function resolveAggregateSensitiveData(payload: V1ResolveAggregateSensitiveDataRequest) {
  const path = `${AGGREGATES_PATH}:resolveSensitiveData`;
  return awPortfolioManagementApi.post<V1ResolveAggregateSensitiveDataResponse>(path, payload);
}

export function updateAggregateMandate(mandate: PortfolioManagementportfoliosv1Mandate) {
  const aggregateTag = mandate.parentReference?.aggregate?.tag;
  const aggregateId = mandate.parentReference?.aggregate?.id;
  const path = `${AGGREGATES_PATH}/${aggregateTag}/${aggregateId}/mandate`;
  return awPortfolioManagementApi.put<PortfolioManagementportfoliosv1Mandate>(path, mandate);
}

export function batchUpdateAggregates(request: V1BatchUpdateAggregatesRequest) {
  const path = `${AGGREGATES_PATH}:batchUpdate`;
  return awPortfolioManagementApi.post<V1BatchUpdateAggregatesResponse>(path, request);
}
